<script setup>
import { dateRanges } from '../helpers/DatePickerHelper';

defineProps({
  selectedRange: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['setRange']);

const setDateRange = range => {
  emit('setRange', range);
};
</script>

<template>
  <div class="flex w-full shrink-0 flex-col items-start sm:w-[168px]">
    <div class="grid w-full grid-cols-2 sm:flex sm:flex-col sm:items-start">
      <button
        v-for="range in dateRanges"
        :key="range.label"
        class="min-h-11 w-full sm:min-h-8 rounded-none border-none px-2.5 py-2 text-start text-sm font-medium leading-4 text-n-slate-12 hover:bg-n-alpha-2 dark:hover:bg-n-solid-3"
        :class="
          range.value === selectedRange &&
          'bg-n-brand/10 text-n-brand hover:bg-n-brand/10 dark:bg-n-brand/20'
        "
        @click="setDateRange(range)"
      >
        {{ $t(range.label) }}
      </button>
    </div>
  </div>
</template>
